import { GET_GPF_HISTORY } from "./types";
import { GpfHistoryType } from "@type/HRM/gpf-history";

export const getGpfHistoryRequest = (data: number | null) => {
  return {
    type: GET_GPF_HISTORY.GET_GPF_HISTORY_REQUEST,
    payload: { data },
  } as const;
};

export const getGpfHistorySuccess = (data: GpfHistoryType) => {
  return {
    type: GET_GPF_HISTORY.GET_GPF_HISTORY_SUCCESS,
    payload: { data },
  } as const;
};

export const getGpfHistoryFailed = () => {
  return {
    type: GET_GPF_HISTORY.GET_GPF_HISTORY_FAILED,
  } as const;
};

export type GpfHistoryActions =
  | ReturnType<typeof getGpfHistoryRequest>
  | ReturnType<typeof getGpfHistorySuccess>
  | ReturnType<typeof getGpfHistoryFailed>;
